import React, { useState, useEffect, useCallback, useRef } from 'react';
import { gql, useQuery } from '@apollo/client';
import * as classes from './blogList.module.css';
import BlogCard from './BlogCard/BlogCard';
import Loader from '../../../common/Loader/Loader';

const GET_FILTERED_BLOGS = gql`
  query($categoryIds: [ID], $endCursor: String) {
    posts(first: 4, after: $endCursor, where: { categoryIn: $categoryIds }) {
      nodes {
        date
        excerpt
        title
        slug
        id
        content
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            name
            databaseId
            uri
            slug
          }
        }
        featuredImage {
          node {
            altText
            mediaItemUrl
          }
        }
        uri
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export default function BlogList({ categoryIds, posts }) {
  const [hasMore, setHasMore] = useState(posts.pageInfo.hasMore);
  const [isLoading, setLoading] = useState(false);
  const [currentList, addToList] = useState([...posts.nodes]);
  const [endCursor, setEndCursor] = useState(posts.pageInfo.endCursor);

  const { error, data, loading } = useQuery(GET_FILTERED_BLOGS, {
    variables: {
      categoryIds: categoryIds,
      endCursor: endCursor,
    },
  });

  const observer = useRef();

  const lastBlogElementref = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          loadBlogs();
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore],
  );

  function loadBlogs() {
    setLoading(true);
    setEndCursor(data.posts.pageInfo.endCursor);
  }

  useEffect(() => {
    if (data) {
      addToList((prevVal) => {
        return [...prevVal, ...data.posts.nodes];
      });
      setHasMore(data.posts.pageInfo.hasNextPage);
    }
    setLoading(false);
  }, [data]);

  if (error) {
    console.error(error);
    return <span>Error !!!</span>;
  }

  const spinner = hasMore ? <Loader /> : null;

  let endResult = !hasMore ? (
    <div>You have reached the end of our appetite.</div>
  ) : null;

  let blogs = currentList;
  return (
    <>
      <div className={classes.container}>
        <div className={classes.flex_container}>
          {blogs.map((blog, index) => {
            if (blogs.length === index + 1) {
              return (
                <div ref={lastBlogElementref} key={blog.id}>
                  <BlogCard blog={blog} />
                </div>
              );
            } else {
              return (
                <div key={blog.id}>
                  <BlogCard blog={blog} />
                </div>
              );
            }
          })}
        </div>
        {endResult}
      </div>
      {spinner}
    </>
  );
}
